import { render } from "./Results.vue?vue&type=template&id=10b79efd&lang=true"
import script from "./Results.vue?vue&type=script&lang=js"
export * from "./Results.vue?vue&type=script&lang=js"

import "./Results.vue?vue&type=style&index=0&id=10b79efd&lang=css"

import exportComponent from "C:\\Users\\Korbin\\Documents\\Vue\\vuetutorial\\reaction-timer\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__